import { Text } from '@components/primitives';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import navigationConstants from '@navigation/navigationConstants';
import { useNavigation } from '@react-navigation/native';
import colors from '@theme/colors';
import React from 'react';
import { Pressable, View } from 'react-native';
import styles from './style';

interface NotificationBellProps {
  notificationCount?: number;
}

const getNotificationBadgeLabel = (notificationCount: number): string =>
  notificationCount > 9 ? '9+' : `${notificationCount}`;

export const notificationBellPressHandler = (navigation: { navigate: (screen: string) => void }): (() => void) => {
  return () => navigation.navigate(navigationConstants.NOTIFICATIONS_INBOX);
};

const NotificationBell: React.FC<NotificationBellProps> = ({ notificationCount = 0 }) => {
  const navigation = useNavigation<any>();
  const showBadge = notificationCount > 0;

  return (
    <Pressable
      testID="notification-bell-button"
      onPress={notificationBellPressHandler(navigation)}
      style={styles.container}>
      <MaterialCommunityIcons testID="notification-bell-icon" color={colors.neutral.cotton} name="bell" size={30} />
      {showBadge ? (
        <View testID="notification-badge" style={styles.badge}>
          <Text testID="notification-badge-text" style={styles.badgeText} variant="xsm-bold">
            {getNotificationBadgeLabel(notificationCount)}
          </Text>
        </View>
      ) : null}
    </Pressable>
  );
};

export default NotificationBell;
